export function formatSalary(salary) {
  if (salary === null || salary === undefined || salary === "") return "";
  const num = Number(salary);
  if (isNaN(num)) return salary;
  return num % 1 === 0 ? num.toFixed(0) : num.toString();
}
